import BackgroundImageLayout from 'src/shared-components/Layout/BackgroundImageLayout';

const Index = () => {
  return <BackgroundImageLayout backgroundImage="bg-apply" isLoading={true} />;
};

export default Index;
